import React from "react";
import { useTranslation } from "react-i18next";
import { useSharingHandlers, useUserIdFromSdk } from "../../../../../../Stores";
import { useProfileDataQuery } from "../../../../../../Api/Queries";
import { ActionIcon, Box, Button, CopyButton, Text, UnstyledButton } from "@mantine/core";
import { MdCheck } from "react-icons/md";
import { Copy } from "../../../../../../Icons";

export const UserIdBlock = () => {
	const { t } = useTranslation();
	const userId = useUserIdFromSdk();
	const { data } = useProfileDataQuery();
	const { linkCopyEnabled } = useSharingHandlers();
	if (!userId) return null;
	return (
		<Box>
			<CopyButton value={userId}>
				{({ copied, copy }) => (
					<Box px="sm" py={5}>
						<UnstyledButton
							component={linkCopyEnabled ? "button" : "div"}
							onClick={copy}
							sx={(theme) => ({
								width: "100%",
								display: "flex",
								alignItems: "center",
								gap: theme.spacing.xs,
								userSelect: "text",
								cursor: linkCopyEnabled ? "pointer" : "auto"
							})}
						>
							<Box sx={{ display: "flex", gap: 5, minWidth: 0 }}>
								<Text c="dimmed" size="sm">
									id:
								</Text>
								<Text c="dark.6" size="sm" truncate sx={{ flexBasis: 0, flexGrow: 1 }}>
									{userId}
								</Text>
							</Box>
							{linkCopyEnabled && (
								<>
									{copied ? (
										<Button
											compact
											color="green"
											variant="filled"
											rightIcon={<MdCheck />}
											component={Box}
										>
											{t("button_copied")}
										</Button>
									) : (
										<ActionIcon variant="subtle" color="dark" size={26} component={Box}>
											<Copy fill="currentColor" width={24} height={24} />
										</ActionIcon>
									)}
								</>
							)}
						</UnstyledButton>
					</Box>
				)}
			</CopyButton>
			{data?.Email && (
				<Text c="dimmed" sx={(theme) => ({ marginLeft: theme.spacing.sm })}>
					{data?.Email}
				</Text>
			)}
		</Box>
	);
};
